<template>
    <div class="h-100">
        <div class="container mt-5 pb-4" v-if="quote_data != null && !quote_data.paid">
            <b-overlay :show="show_overlay" variant="success" :opacity=".5" rounded="sm" style="min-height:100vh;">
                <GardenHelpQuoteDetails v-if="quote_data != null" :quote_table_items="quote_data.items"
                    :contractor_name="quote_data.owner.name" :issue_date="quote_data.created_at"
                    :booking_date="quote_data.model.details.booking_date_web" :quote_number="quote_data.invoice_number"
                    :customer_name="quote_data.model.contact.name" :quote_status="quote_data.status" :quote_paid="quote_data.paid"
                    :subtotal="quote_data.subtotal" :vat="quote_data.vat" :total="quote_data.total"
                    :vat_number="quote_data.owner.vat_number" :contractor_phone="quote_data.owner.phone"
                    :contractor_email="quote_data.owner.email" :currency_code="currency_code"
                    :currency_icon="currency_icon" :isQuote="false" :contractor_address="quote_data.owner.address" :contractor_reg_number="quote_data.owner.company_reg_no" />
                <b-card class="profile-details-card-garden-help my-4" no-body>
                    <b-card-header class=""><b-card-title class="card-title-garden-help">
                            Card Details
                        </b-card-title></b-card-header>
                    <b-card-body class="pt-0 px-4">
                        <StripeComponentPayment v-if="quote_data != null && quote_data.owner != null && quote_data.owner.stripe_account_id!=null" 
                            class="" client_name="GARDENHELP"
                            :connected_account_id="quote_data.owner.stripe_account_id" :require_card="true"
                            :display_img="true" element_class_base="form-control form-control-garden-help"
                            form_group_class="form-group-garden-help" display_label="true"
                            :amount_to_pay="quote_data.total" :payment_intent_desc="payment_intent_desc"
                            :model_type="'job'" :model_id="quote_data.model.id" :variant_primary="'garden-help-primary'"
                            :button_submit_class="'btn-garden-help'"
                            :alert_btn_class="'btn-garden-help btn-garden-help-primary'"
                            :currency_code="currency_code" />
                         <b-card-text v-else-if="quote_data != null && quote_data.owner != null && quote_data.owner.stripe_account_id==null"
                         class="card-text-garden-help" >
                            Your contractor has not properly set up their account for receiving payments yet, please contact them for further information.
                         </b-card-text>   
                    </b-card-body>
                </b-card>

                <!--:job_type="quote_data.model.property.type"-->

            </b-overlay>
        </div>
        <div class="container h-100 d-flex align-items-lg-center" v-if="quote_data != null && quote_data.paid">
            <b-card no-body class="card-success-garden-help mx-auto">
                <b-card-header>
                    <font-awesome-icon icon="fa-solid fa-check" />
                </b-card-header>
                <b-card-title>
                    Paid
                </b-card-title>
                <b-card-body class="mb-5">
                    <b-card-text>
                        This invoice has already been paid.
                    </b-card-text>
                </b-card-body>
            </b-card>
        </div>
    </div>
</template>

<script>
import { getJobStatusClassAndStr } from "@/utils/helper-functions-garden-help.js"
import { formatDateToDMonYear } from "@/utils/helper-functions.js"
import GardenHelpQuoteDetails from "../quotes/QuoteDetails.vue"
import StripeComponentPayment from '@/components/Payment/StripeComponentPayment.vue';
import countries_list from '@/assets/country-list-data.json'


import axios from "axios";

export default {
    name: "GardenHelpInvoicePayment",
    components: {
        GardenHelpQuoteDetails, StripeComponentPayment
    },
    data() {
        return {
            client_name: "GARDENHELP",
            show_overlay: true,

            payment_code: null,
            quote_data: {
                "status": "",
                "subtotal": 0,
                "vat": 0,
                "total": 0,
                "currency": "",
                "model_type": "Job",
                "model_id": null,
                "client": "GARDENHELP",
                "invoice_items": [],
            },
            quote_job: null,
            user_id: null,

            payment_intent_desc: "",

            country: null,
            currency_code: null,
            currency_icon: null

        };
    },
    beforeMount() {
        this.show_overlay = true
    },
    mounted() {
        this.payment_code = this.$route.params.code;
        // this.user_type = localStorage.getItem('user_type')

        console.log(this.$route.params.code)
        console.log(this.payment_code)

        this.show_overlay = true
        this.getPaymentDetails()
    },
    methods: {
        getPaymentDetails() {
            // this.show_overlay = true
            let requestData = { customer_code: this.payment_code }
            axios
                .post("jobs/invoice-by-customer-code", requestData, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                        // Authorization:
                        //     "Bearer " +
                        //     JSON.parse(window.localStorage.getItem("user")).access_token,
                    },
                })
                .then((response) => {
                    console.log(response)
                    console.log(response.data)
                    this.quote_data = response.data.invoice
                    this.quote_job = response.data.invoice.model

                    let services_str = ''
                    for (let i = 0; i < response.data.invoice.items.length; i++) {
                        let item = response.data.invoice.items[i]
                        if (i == response.data.invoice.items.length - 1) {
                            services_str += item.name
                        } else {
                            services_str += item.name + ', '
                        }
                    }

                    this.payment_intent_desc = "Invoice payment for job ("
                        + services_str + ") booked on "
                        + response.data.invoice.model.details.booking_date_web

                    this.currency_code = this.quote_data.currency
                    // console.log(response.data.invoice.currency)
                    const country_data = countries_list.find(({ currency_code }) => currency_code === this.currency_code);
                    // console.log(country_data)

                    this.country = country_data.country
                    this.currency_icon = country_data.currency_icon

                    this.show_overlay = false

                });
        },

    }
};
</script>
<style scoped::v-deep>
@import "../styles/garden-help-button-styles.css";
@import "../styles/garden-help-styles.css";
</style>


// WEBPACK FOOTER //
// src/projects/garden_help/payment/InvoicePayment.vue